<template>
  <div class="referral-sidebar">
    <sidebar-menu-tree v-for="option in menuOptions"
                       :elementId="option.elementId"
                       :clickFunction="option.function"
                       :label="option.label"
                       :icon="option.icon"
                       :current="option.current"
                       :display="option.display"
                       :children="option.children"
                       :key="option.elementId"
                       :notificationCount="option.notificationCount">
    </sidebar-menu-tree>
  </div>
</template>

<script>
// Components
import SidebarMenuTree from '../../common/elements/SidebarMenuTree.vue'

// Libraries
import { mapGetters, mapState } from 'vuex'

// Utilities
import Analytics from '../../../utility/analyticsUtil'
import AppBrowser from '../../../utility/appBrowserUtil'
import Dialog from '../../../utility/dialogUtil'
import Environment from '../../../utility/environmentUtils'
import isEmpty from '../../../utility/isEmpty'
import Logger from '../../../utility/loggerUtil'

import { AnalyticsConstants } from '../../../constants.js'

export default {
  name: 'referral-sidebar',

  components: {
    SidebarMenuTree
  },

  computed: {
    useMenuItemVisibility () {
      return !isEmpty(this.menuItemVisibility)
    },

    currentPage () {
      return this.$route.name
    },

    showLinkAccount () {
      return this.authenticated
    },

    showPrivacyTerms () {
      return true
    },

    showPrivacyPolicy () {
      return true
    },

    showOptInDisclosures () {
      return this.useMenuItemVisibility && !isEmpty(this.menuItemVisibility.optInDisclosuresButton) && this.menuItemVisibility.optInDisclosuresButton === true
    },

    showTermsConditions () {
      return true
    },

    showSignOut () {
      return this.authenticated
    },

    showSignIn () {
      return this.authenticated === false && this.currentPage !== 'AccountStatusBlocked'
    },

    menuOptions () {
      return [
        {
          elementId: 'referralRewardsButton',
          function: () => { this.goAppPage('ReferralRewardsHome') },
          label: this.$t('global.referral_rewards'),
          icon: 'HandshakeIcon',
          current: this.currentPage === 'ReferralRewardsHome',
          display: true
        },
        {
          elementId: 'linkMyAccountButton',
          function: () => { this.goAppPage('LinkAccountOptions') },
          label: this.$t('global.link_account'),
          icon: 'LinkIcon',
          current: this.currentPage === 'LinkAccountOptions',
          display: this.showLinkAccount
        },
        // Add customer profile here. Need page to support
        {
          elementId: 'privacyTermsButton',
          function: () => {},
          label: this.$t('global.privacy_terms'),
          icon: 'PrivacyIcon',
          display: this.showPrivacyTerms,
          children: [
            {
              elementId: 'termsConditionsButton',
              function: async () => {
                if (Environment.isCCFBrandEnv()) {
                  await this.goExternalPage(this.brandedTermsConditionsUrl, 'Terms and Conditions', '_system')
                } else {
                  this.goAppPage(`${this.navigationBrand}-TermsConditions`)
                }
              },
              label: this.$t('global.terms_and_conditions'),
              current: this.currentPage === `${this.navigationBrand}-TermsConditions`,
              display: this.showTermsConditions
            },
            {
              elementId: 'privacyPolicyButton',
              function: async () => { await this.goExternalPage(this.brandedPrivacyPolicyUrl, 'Privacy Notice', '_system') },
              label: this.$t('global.privacy_notice'),
              display: this.showPrivacyPolicy
            },
            {
              elementId: 'optInDisclosuresButton',
              function: () => { this.goAppPage(`${this.navigationBrand}-OptInDisclosures`) },
              label: this.$t('global.opt_in_disclosures'),
              display: this.showOptInDisclosures
            }
          ]
        },
        {
          elementId: 'signoutButton',
          function: () => { this.logout() },
          label: this.$t('global.sign_out'),
          icon: 'SignOutIcon',
          display: this.showSignOut
        }
      ].filter(option => option.display)
    },

    ...mapState('session', ['authenticated', 'menuItemVisibility']),
    ...mapGetters('brands', ['brandedPrivacyPolicyUrl', 'brandedTermsConditionsUrl', 'navigationBrand'])
  },

  methods: {
    goAppPage (routeName) {
      this.$router.push({ name: routeName })

      this.$store.commit('payment/clearPaymentData')
      this.$store.commit('display/toggleSidebar')
    },

    async goExternalPage (url, name, target = '_blank') {
      try {
        Analytics.setScreenName(name)
        const ref = AppBrowser.openInBrowser(url, target)
        return ref
      } catch (e) {
        Logger.error(`Error opening ${url} site link in browser`)
        Logger.debug(e)
        await Dialog.errorAlert(this.$t('global.app_browser_error'))
      }
    },

    async logout () {
      try {
        await this.$store.dispatch('session/signout')

        Analytics.logEvent(AnalyticsConstants.eventName.logout, { method: AnalyticsConstants.method.logout.sideBarButton }, { logMarketingEvent: true })

        this.$router.push({ name: 'Login', params: { signedOut: true } })
      } catch (e) {
        Logger.error('Error attempting to logout and navigate to login page')
        Logger.debug(e)
      }
    }
  }
}
</script>
